<template>
    <ui-modal title="Link do Formulário" icon="far fa-link" name="marketing-queues-form-link" size="xs">
        <form class="form-link">
            <div class="input-group -switch-personalize">
                <ui-switch
                    :id="'marketing-queues-form-link-switch-personalize' + _uid"
                    :checked="showPersonalize"
                    label="Personalizar Link do Formulário"
                    name="remember"
                    design="xs primary"
                    @input="personalizeToggleHandler" />
            </div>

            <div v-if="showPersonalize" class="personalize-form">
                <div class="input-group">
                    <ui-input
                        v-model="models.texto_botao"
                        type="text"
                        label="Texto do Botão:"
                        placeholder="Digite"
                        size="md" />
                </div>

                <div class="cols input-group">
                    <div class="col">
                        <ui-color-picker v-model="models.cor_texto" size="md" label="Cor do Texto" />
                    </div>

                    <div class="col">
                        <ui-color-picker v-model="models.cor_botao" size="md" label="Cor do Botão" />
                    </div>
                </div>

                <div class="cols input-group">
                    <div class="col">
                        <ui-select2
                            v-model="models.ocultar_titulo"
                            :data="defaultOptions"
                            label="Ocultar Título"
                            size="md"
                            item-label="name" />
                    </div>

                    <div class="col">
                        <ui-select2
                            v-model="models.css_disable"
                            :data="defaultOptions"
                            label="Desativar Modelos:"
                            size="md"
                            item-label="name" />
                    </div>
                </div>
            </div>

            <div v-if="showPersonalize" class="input-group -css-external">
                <ui-switch
                    id="marketing-queues-form-link-switch-css-external"
                    :checked="showCssExternal"
                    label="Ativar Link de CSS Externo:"
                    name="remember"
                    design="xs primary"
                    @input="cssExternalToggleHandler" />
                    
                <div v-if="showCssExternal" class="label-group">
                    <ui-input v-model="models.css_link" size="md" group="URL" invertgroup />
                </div>
            </div>

            <div class="input-group button-group">
                <ui-code :copy="doCopy" truncate>{{ fullUrl }}</ui-code>
                <ui-button design="primary md" @click="copyLink">Copiar</ui-button>
            </div>

            <div class="input-group observation">
                <small>OBS.: A personalização do link não será salva.</small>
            </div>
        </form>

        <template #footer>
            <div class="buttons">
                <ui-button design="link lg" @click="cancel">Cancelar</ui-button>
                <ui-button design="lg success mw-100" @click="submit">
                    Abrir Formulário <i class="fal fa-long-arrow-right ml-10"/>
                </ui-button>
            </div>
        </template>
    </ui-modal>
</template>

<script>
	import { uiButton } from '@/components/ui/buttons'
	import { uiModal } from '@/components/ui/modal'
	import { uiCode } from '@/components/ui'
	import { uiSwitch, uiSelect2, uiInput, uiColorPicker } from '@/components/ui/form'
	import { storage } from '@/services/storage'
	import helpers from '@/mixins/helpers'

	export default {
		name: 'ui-form-link-modal',
		components: {
			uiModal,
			uiCode,
			uiButton,
			uiSwitch,
			uiSelect2,
			uiInput,
			uiColorPicker,
		},
		mixins: [helpers],

		data() {
			return {
				showPersonalize: false,
				showCssExternal: false,
                doCopy: false,

				apiConfig: JSON.parse(storage.get('api_config')),
				id: null,

				models: {
					texto_botao: null,
					cor_texto: '#3B4350',
					cor_botao: '#3B4350',
					css_disable: null,
					ocultar_titulo: null,
					css_link: null,
				},

				colorData: {
					color: '#3B4350',
				},

				defaultOptions: [
					{
						id: 0,
						name: 'Sim',
						value: 'yes',
					},
					{
						id: 1,
						name: 'Não',
						value: 'no',
					},
				],
			}
		},

		computed: {
			makeUrl() {
				let hash = btoa(`${this.apiConfig.instance}-${this.id}`)
				let cleanHash = hash.replace(/=/g, '')
				let arrayHash = cleanHash.split('')
				let invertedString = arrayHash[arrayHash.length - 1]

				for (let i = 1; i < arrayHash.length; i++) {
					invertedString += arrayHash[i]

					if (i == arrayHash.length - 2) {
						invertedString += arrayHash[0]
						break
					}
				}

				return (
					(this.apiConfig.environment == 'portainer' || this.apiConfig.environment == 'local'
						? 'http://'
						: 'https://') +
					window.location.host + this.$router.options.base + 'form-public/' + invertedString
				)
			},

			makeOthers() {
				let items = this.models
				let urlParams = '?'

				Object.keys(items).map((e) => {
					let value = items[e]

					if (value !== null && value !== '' && value.value !== 'no') {
						if (value.value == 'yes') {
							urlParams = `${urlParams}&${e}`
						} else {
							urlParams = `${urlParams}&${e}=${value}`
						}
					}
				})

				urlParams = urlParams !== '?' ? encodeURI(urlParams) : ''
				return urlParams
			},

			fullUrl() {
				if (this.showPersonalize) {
					return this.makeUrl + this.makeOthers.replace(/#/g, '%23')
				} else {
					return this.makeUrl
				}
			},
		},

		mounted() {
			this.$root.$on('modal-open-marketing-queues-form-link', (data) => {
				this.id = data
			})
		},

		beforeDestroy() {
			this.$root.$off('modal-open-marketing-queues-form-link')
		},

		methods: {
			cancel() {
				this.$children[0].close()
			},

			submit() {
				window.open(this.fullUrl, 'blank')
			},

            copyLink() {
				this.doCopy = true
				
				setTimeout(() => {
                    this.doCopy = false
                }, 3000)
			},

			personalizeToggleHandler(value) {
				this.showPersonalize = value
			},

			cssExternalToggleHandler(value) {
				this.showCssExternal = value
			},
		}
	}
</script>

<style lang="stylus" scoped>
	@import './styles.styl'
</style>
